import React, { useState, useEffect } from 'react';
import CallController from '../API/CallController';
import '../scss/AddProductForm.scss';

interface Category {
  id: number;
  name: string;
  parentCategoryId?: number | null;
}

const AddProductForm = () => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [priceUnit, setPriceUnit] = useState('kr');
  const [categoryId, setCategoryId] = useState('');
  const [file, setFile] = useState<File | null>(null);
  const [categories, setCategories] = useState<Category[]>([]);
  const [fileName, setFileName] = useState('');

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  useEffect(() => {
    fetch(CallController.GetAllCategories)
      .then(res => res.json())
      .then(data => setCategories(data))
      .catch(err => console.error('Fel vid hämtning av kategorier:', err));
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const token = localStorage.getItem('token'); // Hämta token här

    if (!token) {
      alert('Du måste logga in för att lägga till produkter.');
      return;
    }

    if (!file) {
      alert('Välj en bild!');
      return;
    }

    const formData = new FormData();
    formData.append('Name', name);
    formData.append('Description', description);
    formData.append('Price', price);
    formData.append('PriceUnit', priceUnit);
    formData.append('CategoryId', categoryId);
    formData.append('ImageFile', file);

    try {
      const res = await fetch(CallController.AddProductWithImage, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token || ''}`,  // Skicka med token här
        },
        body: formData,
      });

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(`Fel: ${errorText}`);
      }

      alert('Produkt tillagd!');
      // Reset form:
      setName('');
      setDescription('');
      setPrice('');
      setPriceUnit('kr');
      setCategoryId('');
      setFile(null);
      setFileName('');
    } catch (error) {
      console.error(error);
      alert('Något gick fel vid uppladdning.');
    }
  };

  return (
    <form className="admin-form" onSubmit={handleSubmit}>
      <h2>Lägg till ny produkt</h2>
      <input value={name} onChange={e => setName(e.target.value)} placeholder="Namn" />
      <textarea
        value={description}
        onChange={e => setDescription(e.target.value)}
        placeholder="Beskrivning"
      />
      <div className="price-unit-wrapper">
        <input
          value={price}
          onChange={e => setPrice(e.target.value)}
          placeholder="Pris"
          type="number"
          min="0"
          step="0.01"
        />
        <select value={priceUnit} onChange={e => setPriceUnit(e.target.value)}>
          <option value="kr">kr</option>
          <option value="kr/kg">kr/kg</option>
          <option value="kr/g">kr/g</option>
          <option value="kr/st">kr/st</option>
          <option value="kr/l">kr/l</option>
        </select>
      </div>
      <select value={categoryId} onChange={e => setCategoryId(e.target.value)}>
        <option value="">Välj underkategori</option>
        {categories
          .filter(cat => cat.parentCategoryId !== null && cat.parentCategoryId !== undefined)
          .sort((a, b) => a.name.localeCompare(b.name, 'sv')) // <-- sorterar alfabetiskt
          .map(category => (
            <option key={category.id} value={category.id}>
              {category.name}
            </option>
          ))}
      </select>

      <label className="custom-file-upload">
        <input type="file" onChange={handleFileChange} />
        Välj produktbild
      </label>

      {fileName && <div className="file-name">Vald fil: {fileName}</div>}

      <button type="submit">Lägg till produkt</button>
    </form>
  );


};

export default AddProductForm;
